export default "__VITE_PUBLIC_ASSET__d11fbf10__"